// Roughly the natural width of a download card; also the ceiling for customers who
// own only one or two products, so a lone card doesn't span the whole row.
$maxCardWidth: 300px;

.downloadItemsWrapper {
	@apply yst-grid yst-gap-6;
	// Base tier: one full-width column, no cap (phones).
	grid-template-columns: minmax(0, 1fr);

	// Tailwind's default sm / xl / 2xl breakpoints, matching the utility classes this
	// rule replaced. The column count per tier is capped at the number of downloads by
	// DownloadItems.jsx. Only the custom property is redefined per tier — both
	// grid-template-columns and max-width read it.
	@media screen and (min-width: 640px) {
		--download-columns: var(--download-columns-sm, 2);

		grid-template-columns: repeat(var(--download-columns), minmax(0, 1fr));
		// 1.5rem is the yst-gap-6 value.
		max-width: calc(var(--download-columns) * #{$maxCardWidth} + (var(--download-columns) - 1) * 1.5rem);
	}

	@media screen and (min-width: 1280px) {
		--download-columns: var(--download-columns-xl, 3);
	}

	@media screen and (min-width: 1536px) {
		--download-columns: var(--download-columns-2xl, 5);
	}
}
